import * as React from 'react';
import styled from 'styled-components';
import { theme } from 'components';
import { ListingLabelContext } from 'contexts';

interface Props {
  viewPage: (page: number) => any;
  select: (index: number) => any;
  listings: any[];
  count: number;
  page: number;
  limit: number;
  selected?: string;
}

const ListingsContainer = (props: Props) => {
  const { getLabel, getAvailability } = React.useContext(ListingLabelContext);

  const { listings, count, page, limit, viewPage, selected } = props;
  const last = Math.ceil(count / limit) - 1;
  const goToPage = (pageNumber: number) => () => viewPage(pageNumber);

  const pageLinks = [];
  const pageStart = Math.max(0, Math.min(page - 2, last - 4));
  const pageEnd = Math.min(last, pageStart + 4);
  for (let i = pageStart; i <= pageEnd; i++) {
    pageLinks.push(
      <li className={i === page ? 'active' : ''} key={i}>
        <a onClick={goToPage(i)}>{i + 1}</a>
      </li>,
    );
  }

  return (
    <div style={{ marginTop: 20 }}>
      {listings.length === 0 ? (
        <div>
          <h4>No listings found.</h4>
        </div>
      ) : (
        <div>
          <div className="pull-right">
            <h5
              style={{
                marginLeft: '15px',
                marginTop: '10px',
                marginRight: '5px',
              }}
            >
              Total {count}
            </h5>
          </div>
          {count > limit && (
            <div className="pull-right">
              <nav>
                <ul
                  className="pagination-sm pagination"
                  style={{ marginTop: 5, marginBottom: 5 }}
                >
                  <li className={page === 0 ? 'disabled' : ''}>
                    <a onClick={goToPage(0)}>&laquo;</a>
                  </li>
                  <li className={page === 0 ? 'disabled' : ''}>
                    <a onClick={goToPage(page - 1)}>&lsaquo;</a>
                  </li>
                  {pageLinks}
                  <li className={page === last ? 'disabled' : ''}>
                    <a onClick={goToPage(page + 1)}>&rsaquo;</a>
                  </li>
                  <li className={page === last ? 'disabled' : ''}>
                    <a onClick={goToPage(last)}>&raquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          )}
          <table className="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Address</th>
                <th>Price</th>
                <th>{getLabel('Availability')}</th>
                <th>Agent</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {listings.map((listing, index) => (
                <tr key={listing.id}>
                  <td>
                    {listing.line1} {listing.line2}
                    <br />
                    <small>
                      {listing.city} {listing.province} {listing.postal_code}
                    </small>
                  </td>
                  <StyledDarkTd>
                    $
                    {listing.type === 'commercial'
                      ? listing.list_price.formatMoney(2)
                      : listing.list_price.formatMoney(0)}
                    {listing.sold_details &&
                      listing.availability === 'Sold' &&
                      listing.sold_details.price && (
                        <div>
                          S: $
                          {listing.type === 'commercial'
                            ? listing.sold_details.price.formatMoney(2)
                            : listing.sold_details.price.formatMoney(0)}
                        </div>
                      )}
                    {listing.leased_details &&
                      listing.availability === 'Leased' &&
                      listing.leased_details.price && (
                        <div>
                          L: $
                          {listing.type === 'commercial'
                            ? listing.leased_details.price.formatMoney(2)
                            : listing.leased_details.price.formatMoney(0)}
                        </div>
                      )}
                  </StyledDarkTd>
                  <StyledDarkTd>
                    {getAvailability(listing.availability)}
                  </StyledDarkTd>
                  <StyledDarkTd>
                    {listing.fullReps.map((rep: any) => (
                      <div key={rep.id}>
                        {rep.firstName} {rep.lastName}
                      </div>
                    ))}
                  </StyledDarkTd>
                  <td>
                    {selected !== listing.id ? (
                      <button
                        className="btn btn-default"
                        onClick={() => props.select(listing)}
                        data-cy={`merge-select-listing-${listing.id}`}
                      >
                        Select
                      </button>
                    ) : (
                      <button className="btn btn-default disabled" disabled>
                        Selected
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ListingsContainer;

const StyledDarkTd = styled.td`
  color: ${theme.gray8};
`;
